export default __webpack_public_path__ + "static/media/security-fill.8bbd0fc5.svg";